module.exports = __webpack_public_path__ + "static/media/logo1.ca37ce63.png";